import { Root, PillColorType } from './Pill.styles'

export type { PillColorType }

export default Root
